var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgOccupancy = function SvgOccupancy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9466595,42.035499 L10.7008928,42.035499 C7.99491996,42.035499 7.07242916,39.8318821 7.07242916,37.0616209 L7.07242916,6.08506363 C7.07242916,4.51105157 6.45743534,3 3.19796798,3 C1.22998769,3 0.184498153,4.0703282 0,5.64434026 L0,93.9149364 C0,95.4889482 0.922490761,97 3.25946737,97 C5.65794335,97 6.88793102,95.9926326 7.07242916,94.3556596 L7.07242916,77.9229738 L92.802571,77.9229738 L92.802571,93.9149364 C92.802571,95.4889482 93.9095597,97 96.4310345,97 C98.7065118,97 99.6905021,95.9926326 99.875,94.3556596 L99.875,58.3422639 C99.8135005,49.3389149 92.7410715,42.035499 83.9466595,42.035499 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46529563,6 L2.64781491,6 C2.28791774,6 2,5.70212766 2,5.32978723 L2,3.55319149 C2,3.24468085 2.23650386,3 2.53470437,3 L3.63496144,3 C4.94087404,3 6,4.09574468 6,5.44680851 C6,5.75531915 5.76349614,6 5.46529563,6 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgOccupancy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "occupancy.de21ca66cef6ba2cc397ff67bada2e11.svg";